module.exports = __webpack_public_path__ + "media/images/icon_comment_gray-68ae05c5454e71c5686eb02dd2af2206.png";